import { useState } from "react";
import { Expand, Expanded } from "../Icons";
import { H3 } from "../Headers/Headings";
import { Expandable } from "../Expandable/Expandable";
import styles from "./Collapsable.module.css";

type ComponentProps = {
  children: React.ReactNode;
  toggleItem: React.ReactNode | string;
  closed: boolean;
};

const Collapsable = ({ children, toggleItem, closed }: ComponentProps) => {
  const [isExpanded, setIsExpanded] = useState(!closed);

  return (
    <div className={styles.container}>
      <button
        className={[styles.toggle, isExpanded && styles.toggleExpanded].filter(Boolean).join(" ")}
        onClick={() => setIsExpanded(!isExpanded)}
        type='button'
      >
        <H3 variant='flush'>{toggleItem}</H3>
        <span className={styles.icon}>{isExpanded ? <Expanded /> : <Expand />}</span>
      </button>
      <Expandable isOpen={isExpanded}>
        <div className={styles.content}>{children}</div>
      </Expandable>
    </div>
  );
};

export default Collapsable;
